import { DataCenter } from "./DataCenter";
import { MainStorage } from "./MainStorage";

export class StatLoader
{
    public callback: Function;
    private subjectID: number=0;
    private ms:MainStorage=MainStorage.getInstance();
    constructor(callback: Function) {
        this.callback = callback;
    }
    public loadStats(subjectID: number) {
        this.subjectID = subjectID;
        DataCenter.getTriedGames(this.ms.userCode,subjectID, this.onStatsLoaded.bind(this));
    }
    private onStatsLoaded(data: any) {
           // console.log(data);
            let played:any=data.games;
            let playedIDs:number[]=[];
            for (let i:number=0;i<played.length;i++)
            {
                playedIDs.push(parseInt(played[i]));
            }
            this.ms.playedGames=playedIDs;
            this.getUnlockedLevels();
    }
    private getUnlockedLevels()
    {
        DataCenter.getUnlocks(this.ms.userCode,this.subjectID,this.onUnlocksLoaded.bind(this));
    }
    public getPlayedGames(subjectID:number)
    {
        this.subjectID=subjectID;
        DataCenter.getGamesPlayed(this.ms.userCode,subjectID,this.gotPlayedGames.bind(this));
    }
    private gotPlayedGames(data:any)
    {
        console.log(data);
        let ids:number[]=[];
        for (let i:number=0;i<data.gamesPlayed.length;i++)
        {
            let gamePlayed:any=data.gamesPlayed[i];
            console.log(gamePlayed);
            ids.push(parseInt(gamePlayed.workID));
        }
        this.ms.playedGames=ids;
        this.getCompletedTopics();
    }
    getCompletedTopics()
    {
        DataCenter.getTopicsCompleted(this.ms.userCode,this.subjectID,this.gotCompletedTopics.bind(this));
    }
    private gotCompletedTopics(data:any)
    {
        console.log(data);
        let ids:number[]=[];
        for (let i: number = 0; i < data.completedTopics.length;i++)
        {
            let topic: any = data.completedTopics[i];
            ids.push(parseInt(topic.id));
        }
        console.log(ids);
      //  this.ms.completedTopics=ids;
        this.ms.unlockedGames=ids;
        this.callback();
    }
    onUnlocksLoaded(data:any)
    {
       // console.log(data);
        let unlocked:any=data.unlocks;
        let unlockedIDs:number[]=[];
        for (let i:number=0;i<unlocked.length;i++)
        {
            unlockedIDs.push(parseInt(unlocked[i]));
        }
        this.ms.unlockedGames=unlockedIDs;
        this.callback(data);
    }
}